/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {VerifyPasskeyRequest} from '@cash-web/protos/squareup/cash/janus/api/WebAuthn.pb'
import {VerifyPasskeyResponse} from '@cash-web/protos/squareup/cash/janus/api/WebAuthn.pb'


export const verifyPasskey = (request: VerifyPasskeyRequest, options?: CashRequestOptions) => post<VerifyPasskeyRequest, VerifyPasskeyResponse>("/2.0/cash/verify-passkey", request, {...options, rejectOnError: true })